import { useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const EXCLUDED_PARAMS = new Set(['formId', 'formView']);

const LinkWithPersistedParams = ({ children, className, onClick, to }) => {
  const [searchParams] = useSearchParams();

  const persistedTo = useMemo(() => {
    const url = new URL(to, window.location.origin);
    searchParams.forEach((value, key) => {
      if (!EXCLUDED_PARAMS.has(key)) url.searchParams.set(key, value);
    });
    return `${url.pathname}${url.search}`;
  }, [searchParams, to]);

  return (
    <Link
      onClick={onClick}
      to={persistedTo}
      className={className}
    >
      {children}
    </Link>
  );
}

export default LinkWithPersistedParams;
